/**
 * Extend functionalities of the custom_openlayers widget
 *
 * this come from the way the widget is built by custom-openlayers.html
 * geodjango_coordinates = new MapWidget()
 */
var OADForm = /** @class */ (function () {
    function OADForm() {
        var _this = this;
        /**
         *mygeowidget = geodjango_coordinates;
         */
        this.mygeowidget = geodjango_coordinates;
        this.postalCode = document.getElementById("id_postalcode");
        this.loadData = Array.from(document.getElementsByClassName("load-data"));
        // zip code change event
        // document.getElementById("id_postalcode").change(this.onZipChange);
        this.postalCode.addEventListener("change", function (event) {
            _this.onZipChange();
        });
        // animated load button
        // document.getElementsByClassName("load-data").click(this.onLoadButton);
        this.loadData.forEach(function (btn) {
            btn.addEventListener("click", function (event) {
                _this.onLoadButton();
            });
        });
        // if upload of csv is available
        if (document.getElementById("id_source_of_data")) {
            document
                .getElementById("id_source_of_data")
                .addEventListener("change", function (event) {
                _this.onSODChange();
            });
            this.onSODChange();
        }
        return;
    }
    OADForm.prototype.onLoadButton = function () {
        var mybtn = document.getElementById("ldbtn");
        mybtn.innerText = "";
        mybtn.classList.toggle("spinner-border");
        mybtn.classList.toggle("text-success");
        return;
    };
    OADForm.prototype.onSODChange = function () {
        /**
         * Display the file field if Source Of Data is file
         */
        if (document.getElementById("id_source_of_data").value ==
            "file") {
            if (document.getElementById("id_filecsv")) {
                document.getElementById("id_filecsv").parentElement.style.display =
                    "block";
                document.getElementById("id_date_start").parentElement.parentElement.style.display = "none";
                document.getElementById("id_date_end").parentElement.parentElement.style.display = "none";
                document.getElementById("id_postalcode").parentElement.style.display =
                    "none";
            }
        }
        else {
            if (document.getElementById("id_filecsv")) {
                document.getElementById("id_filecsv").parentElement.style.display =
                    "none";
                document.getElementById("id_date_start").parentElement.parentElement.style.display = "block";
                document.getElementById("id_date_end").parentElement.parentElement.style.display = "block";
                document.getElementById("id_postalcode").parentElement.style.display =
                    "block";
            }
        }
        return;
    };
    OADForm.prototype.onZipChange = function () {
        /*
         * center the map on the selected zip code
         */
        var lat;
        var lon;
        lat = this.postalCode.selectedOptions[0].getAttribute("latitude");
        lon = this.postalCode.selectedOptions[0].getAttribute("longitude");
        this.mygeowidget.options.default_lat = parseFloat(lat);
        this.mygeowidget.options.default_lon = parseFloat(lon);
        // remove existing points on the map
        this.mygeowidget.clearFeatures();
        // re-center and re-zoom the map
        this.mygeowidget.map.getView().setCenter(this.mygeowidget.defaultCenter());
        this.mygeowidget.map
            .getView()
            .setZoom(this.mygeowidget.options.default_zoom);
        return;
    };
    return OADForm;
}());
export { OADForm };
